(function() {

  // ─── Sticky bar mobile-only logic ─────────────────────────────────────────

  function initStickyBar() {
    var bar     = document.getElementById('StickyATCBar');
    var btn     = document.getElementById('StickyATCButton');
    var sizeEl  = document.getElementById('StickyATCSelectedSize');

    if (!bar || !btn) return;

    // Trigger: show bar only after the size swatch section has scrolled out of view.
    // Re-query the sentinel on every tick — the theme replaces DOM nodes on variant swaps
    // so a captured reference becomes stale and returns getBoundingClientRect() of all zeros.
    function checkVisibility() {
      var sentinel = document.querySelector('product-swatch:not(.is-color-swatch)') ||
                     document.querySelector('button[name="add"]');
      if (!sentinel) return;
      var rect = sentinel.getBoundingClientRect();
      // Show bar once the bottom of the size swatch is above the viewport
      if (rect.bottom < 0) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    checkVisibility();

    // Button behaviour
    btn.addEventListener('click', function() {
      var selectedSize = window._tyrSelectedSize || null;

      if (!selectedSize) {
        // No size selected — smooth scroll to size swatch
        var target = document.querySelector('product-swatch:not(.is-color-swatch)');
        if (target) {
          var targetTop = target.getBoundingClientRect().top + window.scrollY - 20;
          window.scrollTo({ top: targetTop, behavior: 'smooth' });
        }
        return;
      }

      // Size selected — trigger the main ATC button
      var mainBtn = document.querySelector('button[name="add"]');
      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
      }
    });

    // Update button text and selected size display
    function updateBarState() {
      var selectedSize = window._tyrSelectedSize || null;
      if (selectedSize) {
        btn.textContent = 'Add to Cart';
        if (sizeEl) {
          sizeEl.textContent = 'Size: ' + selectedSize;
          sizeEl.style.display = '';
        }
      } else {
        btn.textContent = 'Select a Size';
        if (sizeEl) {
          sizeEl.textContent = '';
          sizeEl.style.display = 'none';
        }
      }
    }

    // Expose so variant logic below can call it
    window._updateStickyBarState = updateBarState;

    // Update sticky bar product info (image, title, price) from the live DOM
    function updateBarProductInfo() {
      var stickyImg   = document.getElementById('StickyATCImage');
      var stickyTitle = document.getElementById('StickyATCTitle');
      var stickyPrice = document.getElementById('StickyATCPrice');

      // Title: read from the page h1
      if (stickyTitle) {
        var pageTitle = document.querySelector('h1.product__title, .product__title h1, h1');
        if (pageTitle) stickyTitle.textContent = pageTitle.textContent.trim();
      }

      // Price: read from the main price element
      if (stickyPrice) {
        var pagePrice = document.querySelector('.price__regular .price-item--regular, .price-item--regular');
        if (pagePrice) stickyPrice.textContent = pagePrice.textContent.trim();
      }

      // Image: use the color swatch image map built in stickyATCInit,
      // or fall back to the first product image in the gallery
      if (stickyImg) {
        var checkedColor = document.querySelector('input[type="radio"][name*="option-1"]:checked');
        var colorValue = checkedColor ? checkedColor.value : null;
        var map = window._stickySwatchImageMap || {};
        var newSrc = colorValue ? map[colorValue] : null;
        if (!newSrc) {
          // Fallback: first gallery image
          var galleryImg = document.querySelector('.product__media img, .product-media img, .product__image');
          if (galleryImg) newSrc = galleryImg.src;
        }
        if (newSrc) stickyImg.src = newSrc;
      }
    }

    // Expose so navigatesuccess and variant:updated can call it
    window._updateStickyBarProductInfo = updateBarProductInfo;

    // Sync on load
    updateBarState();
    updateBarProductInfo();
  }

  // ─── Variant / OOS logic ──────────────────────────────────────────────────

  function stickyATCInit() {
    // Build color → product fetch URL map (TYR combined listing)
    var colorFetchUrlMap = {};
    var colorRadios = document.querySelectorAll('input[type="radio"][name*="option-1"]');
    colorRadios.forEach(function(r) {
      if (r.dataset.productFetchUrl) {
        colorFetchUrlMap[r.value] = r.dataset.productFetchUrl;
      }
    });

    // Build color → swatch image map
    var colorSwatchImageMap = {};
    colorRadios.forEach(function(r) {
      var label = document.querySelector('label[for="' + r.id + '"]');
      if (!label) return;
      var bg = window.getComputedStyle(label).backgroundImage;
      if (bg && bg !== 'none') {
        var match = bg.match(/url\(["']?([^"')]+)["']?\)/);
        if (match && match[1]) {
          var imgSrc = match[1].replace(/width=\d+/, 'width=150');
          if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
          colorSwatchImageMap[r.value] = imgSrc;
        }
      }
    });
    window._stickySwatchImageMap = colorSwatchImageMap;

    // Cache: colorHandle → array of variant objects
    var sizeOosCache = {};

    // Determine combined listing vs single product
    var firstColorRadio = document.querySelector('input[type="radio"][name*="option-1"]');
    var isCombinedListing = firstColorRadio
      ? firstColorRadio.getAttribute('data-is-combined-listing') === 'true'
      : false;

    var sizeOptionSelector = isCombinedListing
      ? 'input[type="radio"][name*="option-3"]'
      : 'input[type="radio"][name*="option-2"]';

    // ── Helpers ───────────────────────────────────────────────────────────────

    function isSizeRadio(nameAttr, target) {
      if (nameAttr.indexOf('option-2') === -1 && nameAttr.indexOf('option-3') === -1) return false;
      var parentSwatch = target.closest('product-swatch');
      if (parentSwatch && parentSwatch.classList.contains('is-color-swatch')) return false;
      return true;
    }

    function recheckSizeRadio(sizeValue) {
      if (!sizeValue) return;
      var radios = document.querySelectorAll(sizeOptionSelector);
      radios.forEach(function(r) {
        if (r.value === sizeValue) {
          r.checked = true;
          var wrapper = r.closest('.swatch-element');
          if (wrapper) wrapper.classList.add('active');
        }
      });
    }

    function applyColorOosClasses(selectedSize) {
      var colorSwatchEls = document.querySelectorAll('.swatch-element.color');
      if (!colorSwatchEls.length) return;

      if (!isCombinedListing) {
        colorSwatchEls.forEach(function(swatchEl) {
          var input = swatchEl.querySelector('input[type="radio"]');
          if (!input) return;
          var colorValue = input.value;
          var productSwatchEl = swatchEl.closest('product-swatch');
          if (!productSwatchEl) return;
          var variantScripts = productSwatchEl.querySelectorAll('script[type="application/json"][data-resource]');
          var isOosInSize = false;
          variantScripts.forEach(function(script) {
            try {
              var variant = JSON.parse(script.textContent);
              if (variant && variant.option1 === colorValue && variant.option2 === selectedSize) {
                if (!variant.available) isOosInSize = true;
              }
            } catch (e) {}
          });
          isOosInSize ? swatchEl.classList.add('color-oos-in-size') : swatchEl.classList.remove('color-oos-in-size');
        });
      } else {
        colorSwatchEls.forEach(function(swatchEl) {
          var input = swatchEl.querySelector('input[type="radio"]');
          if (!input) return;
          var fetchUrl = input.getAttribute('data-product-fetch-url');
          if (!fetchUrl) return;
          var handle = fetchUrl.split('/products/')[1];
          if (!handle) return;
          handle = handle.split('?')[0];

          function applyFromData(variants) {
            var sizeExists = false;
            var isOosInSize = false;
            variants.forEach(function(v) {
              if (v.option3 === selectedSize) {
                sizeExists = true;
                if (!v.available) isOosInSize = true;
              }
            });
            // Treat missing size variant same as OOS — strikethrough the color swatch
            var shouldStrike = isOosInSize || !sizeExists;
            shouldStrike ? swatchEl.classList.add('color-oos-in-size') : swatchEl.classList.remove('color-oos-in-size');
          }

          if (sizeOosCache[handle]) { applyFromData(sizeOosCache[handle]); return; }

          var jsonUrl = '/products/' + handle + '.js';
          var xhr = new XMLHttpRequest();
          xhr.open('GET', jsonUrl, true);
          xhr.onload = function() {
            if (xhr.status === 200) {
              try {
                var data = JSON.parse(xhr.responseText);
                if (data.variants) { sizeOosCache[handle] = data.variants; applyFromData(data.variants); }
              } catch (e) {}
            }
          };
          xhr.send();
        });
      }
    }

    function setAtcNoSizeState() {
      var btn = document.querySelector('button[name="add"]');
      var span = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
      if (btn && span) {
        span.textContent = 'Select Size';
        btn.disabled = true;
        btn.setAttribute('data-tyr-size-required', 'true');
      }
      if (typeof window._updateStickyBarState === 'function') window._updateStickyBarState();
    }

    function setAtcReadyState() {
      var btn = document.querySelector('button[name="add"]');
      var span = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
      if (btn && span && btn.getAttribute('data-tyr-size-required') === 'true') {
        span.textContent = 'Add to cart';
        btn.disabled = false;
        btn.removeAttribute('data-tyr-size-required');
      }
      if (typeof window._updateStickyBarState === 'function') window._updateStickyBarState();
    }

    // Auto-select only when the product exposes exactly one enabled size named “One Size”.
    // This keeps the existing explicit-selection behavior for all multi-size products.
    function selectOnlyOneSize() {
      var sizeRadios = Array.from(document.querySelectorAll(sizeOptionSelector));

      if (
        sizeRadios.length !== 1 ||
        sizeRadios[0].disabled ||
        sizeRadios[0].value.trim().toLowerCase() !== 'one size'
      ) {
        return null;
      }

      var radio = sizeRadios[0];
      radio.checked = true;

      var wrapper = radio.closest('.swatch-element');
      if (wrapper) wrapper.classList.add('active');

      window._tyrSelectedSize = radio.value;
      return radio.value;
    }

    function applyAllSizeState() {
      var selectedSize = window._tyrSelectedSize || selectOnlyOneSize();
      if (selectedSize) {
        recheckSizeRadio(selectedSize);
        applyColorOosClasses(selectedSize);
        setAtcReadyState();
      } else {
        setAtcNoSizeState();
      }
    }

    // ── Document-level size radio change listener ─────────────────────────────
    if (!window._tyrSizeListenerAttached) {
      document.addEventListener('change', function(e) {
        if (!e.target || !e.target.name) return;
        if (!isSizeRadio(e.target.name, e.target)) return;
        window._tyrSelectedSize = e.target.value;
        applyColorOosClasses(e.target.value);
        if (typeof window._updateStickyBarState === 'function') window._updateStickyBarState();
      });
      window._tyrSizeListenerAttached = true;
    }

    // ── variant:updated hook ──────────────────────────────────────────────────
    if (!window._tyrVariantUpdatedListenerAttached) {
      if (typeof eventBus !== 'undefined') {
        eventBus.on('variant:updated', function() {
          requestAnimationFrame(function() {
            applyAllSizeState();
            // Sync sticky bar product info after every DOM swap
            if (typeof window._updateStickyBarProductInfo === 'function') {
              window._updateStickyBarProductInfo();
            }
          });
        });
        window._tyrVariantUpdatedListenerAttached = true;
      }
    }

    // ── Color radio change — update sticky bar image/title/price ─────────────
    if (!window._tyrColorListenerAttached) {
      document.addEventListener('change', function(e) {
        if (!e.target || !e.target.name) return;
        if (e.target.name.indexOf('option-1') === -1) return;
        // Small delay to let the theme update the page title/price first
        setTimeout(function() {
          if (typeof window._updateStickyBarProductInfo === 'function') {
            window._updateStickyBarProductInfo();
          }
        }, 100);
      });
      window._tyrColorListenerAttached = true;
    }

    // ── Initial page load state ───────────────────────────────────────────────
    var checkedSizeRadio = document.querySelector(sizeOptionSelector + ':checked');
    var initialSize = checkedSizeRadio
      ? checkedSizeRadio.value
      : selectOnlyOneSize();

    if (initialSize) {
      recheckSizeRadio(initialSize);
      applyColorOosClasses(initialSize);
      setAtcReadyState();
    } else {
      setTimeout(setAtcNoSizeState, 150);
    }
  }

  // ─── Bootstrap ────────────────────────────────────────────────────────────

  function runInit() {
    // Clear a prior product's selection before detecting this product's size.
    window._tyrSelectedSize = null;

    stickyATCInit();
    initStickyBar();

    if (typeof window._updateStickyBarState === 'function') window._updateStickyBarState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  // Size radio change — keep stored size in sync
  document.addEventListener('change', function(e) {
    if (!e.target || !e.target.name) return;
    if (e.target.name.indexOf('option-2') === -1 && e.target.name.indexOf('option-3') === -1) return;
    var parentSwatch = e.target.closest && e.target.closest('product-swatch');
    if (parentSwatch && parentSwatch.classList.contains('is-color-swatch')) return;
    window._tyrSelectedSize = e.target.value;
  });

  // Re-run after Navigation API navigations (footwear color changes)
  if (window.navigation) {
    var _lastProductPath = location.pathname;
    window.navigation.addEventListener('navigatesuccess', function() {
      var newPath = location.pathname;
      var productHandleChanged = newPath !== _lastProductPath;
      _lastProductPath = newPath;
      if (productHandleChanged) {
        window._tyrSelectedSize = null;
        setTimeout(function() {
          runInit();
          if (typeof window._updateStickyBarProductInfo === 'function') {
            window._updateStickyBarProductInfo();
          }
        }, 50);
      }
    });
  }

  })();
